import { Metadata } from 'lib/rich/metadata'
import { InstanceProperties, RichType } from 'lib/rich/rich-type'
import { UnitShorthand } from 'types/unit-shorthand'
import { unit_metadata } from './common'

export class Material extends RichType {
  static unit_metadata: Metadata = unit_metadata
  unit: UnitShorthand

  /* 
  Legacy fields from Prisma table (which supposedly have origins to HSM Advisor).
  We may want to re-introduce some of these later as needed.

  static hb_metadata: Metadata = {
    title: 'Hardness',
    kind: 'hardness',
    default_value: 95, // (aluminium)
    required: true,
    gt: 0.0,
  }
  hb: number

  // aka Power Factor
  static powerPerMRR_metadata: Metadata = {
    title: 'Power per MRR',
    kind: 'unitless',
    default_value_in: 0.254, // (aluminium)
    required: true,
    gt: 0.0,
  }
  powerPerMRR: number

  static surfaceSpeed_metadata: Metadata = {
    title: 'Surface Speed',
    kind: 'surface_speed',
    default_value_in: 600, // (aluminium)
    required: true,
    gt: 0.0,
  }
  surfaceSpeed: number

  static targetChipLoad_metadata: Metadata = {
    title: 'Target Chip Load',
    kind: 'chip_load',
    default_value_in: 0.00391666666666667, // (aluminium)
    required: true,
    gt: 0.0,
  }
  targetChipLoad: number

  static coatingReduction_metadata: Metadata = {
    title: 'Coating Reduction',
    kind: 'unitless',
    default_value: 0.9,
    required: true,
    gt: 0.0,
  }
  coatingReduction: number

  static materialReduction_metadata: Metadata = {
    title: 'Material Reduction',
    kind: 'unitless',
    default_value: 0.5,
    required: true,
    gt: 0.0,
  }
  materialReduction: number
*/

  static density_metadata: Metadata = {
    title: 'Density',
    kind: 'density',
    default_value_mm: 2710, // kg/m3 (aluminium)
    required: true,
    gt: 0.0,
  }
  density: number

  static powerFactor_metadata: Metadata = {
    title: 'Power Factor',
    kind: 'unitless',
    default_value: 0.3, // (6000 aluminium)
    required: true,
    gt: 0.0,
  }
  powerFactor: number

  // Maybe add other properties like:
  //  - Elastic Modulus (Young's Modulus)
  //  - Yield Strength
  //  - Ultimate Tensile Strength
  //  - Thermal Conductivity
  //  - Specific Heat Capacity
  //  - Melting Point

  static version = 1
}

export type MaterialData = InstanceProperties<Material>
